import React from 'react';
import { storesContext } from '../stores/context/';

const useStores = () => React.useContext(storesContext);

export default useStores;